module.exports = "<div class=\"q-col-3 q-no-pad per-page-select\"> <select name=totalPerPage class=\"total-per-page select2-select\" data-s2-minimum-results-for-search=Infinity> <option value=10>10 Per Page</option> <option value=25>25 Per Page</option> <option value=50>50 Per Page</option> <option value=100>100 Per Page</option> </select> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lookupTable/html/perPageSelect.html
// module id = 1160
// module chunks = 1